/**
 * Brand assets - one source of truth.
 *
 * `/logo.png` is the supplied logo file with only the empty transparent
 * margin trimmed off (artwork, colours and proportions untouched) so it
 * renders large and sharp instead of floating inside blank space.
 * `/logo-square.png` is the same artwork padded - never cropped or recoloured
 * - to a square for icon slots.
 */
export const LOGO = '/logo.png';
export const LOGO_SQUARE = '/logo-square.png';

// 1200x630 share card: the untouched logo centered on solid black, so link
// previews fill the frame instead of letterboxing a transparent PNG.
export const SHARE_CARD_PATH = '/share-card.png';
export const SHARE_CARD = 'https://www.outlawmedia.com.au/share-card.png';

// Absolute URL of the untouched original, for share cards + structured data.
export const LOGO_ABSOLUTE =
  'https://customer-assets-cm19k8pv.emergentagent.net/job_d497ffe6-f7ac-4d46-ab2f-f65a2fd380b7/artifacts/w55xp1p3_OUTLAW%20%281600%20x%20500%20px%29_20260929_235820_0000.png';

export const LOGO_WIDE = LOGO;
export const SOCIAL_CARD = SHARE_CARD;
